import React from "react";
import { EaKpiCard } from "./EaUi";
import { fmtQty } from "./eaFormat";

// Costo medio fatturato e costo medio anno stimato nella stessa card, ben distinti.
export function EaAvgCostCard({ block, label, unit, accent, band, testid, conv = (v) => v, icon, chart }) {
  return (
    <EaKpiCard label={label} accent={accent} band={band} icon={icon} chart={chart} value={fmtQty(conv(block.avg_cost), 2, unit)} testid={testid}
      sub={`Fatturato: totale fatture ÷ consumi dei soli mesi fatturati (${block.months_invoiced} completi${block.months_partial?.length ? ` + ${block.months_partial.length} parziali` : ""})`}>
      <div className="mt-1 pt-2 border-t border-slate-100" data-testid={`${testid}-year`}>
        <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-400">Anno stimato (incl. forecast)</div>
        <div className="font-display text-lg font-bold text-slate-700 font-mono-nums">{fmtQty(conv(block.avg_cost_year), 2, unit)}</div>
        <div className="text-xs text-slate-500">Forecast anno ÷ consumi dell'anno, come nel Report</div>
      </div>
    </EaKpiCard>
  );
}
